import React from 'react';
import { useTranslation } from 'next-i18next';

const Features = () => {
  const { t } = useTranslation('common');

  const features = [
    {
      title: t('feature_1_title'),
      description: t('feature_1_desc'),
      icon: '📺'
    },
    {
      title: t('feature_2_title'),
      description: t('feature_2_desc'),
      icon: '📱'
    },
    {
      title: t('feature_3_title'),
      description: t('feature_3_desc'),
      icon: '🛍️'
    },
    {
      title: t('feature_4_title'),
      description: t('feature_4_desc'),
      icon: '👗'
    },
    {
      title: t('feature_5_title'),
      description: t('feature_5_desc'),
      icon: '🎬'
    },
    {
      title: t('feature_6_title'),
      description: t('feature_6_desc'),
      icon: '📝'
    }
  ];

  return (
    <section className="py-16 bg-gray-50">
      <div className="max-w-6xl mx-auto px-4">
        <div className="text-center mb-12">
          <h2 className="text-4xl font-bold text-gray-800 mb-4">
            {t('features_title')}
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            {t('features_subtitle')}
          </p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {features.map((feature, index) => (
            <div key={index} className="bg-white rounded-lg p-6 shadow-md hover:shadow-lg transition-shadow">
              <div className="text-4xl mb-4">{feature.icon}</div>
              <h3 className="text-xl font-semibold text-gray-800 mb-3">
                {feature.title}
              </h3>
              <p className="text-gray-600 leading-relaxed">
                {feature.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Features;